import { useGetAuthQuery } from "../features/api";

/**
 *
 * @param companyType 許可する事業者種別
 * @returns 許可する事業者種別がログインユーザの事業者種別と同じかフラグ
 */
export const useCanIShowHook = (companyType: string): boolean => {
  // 権限取得
  const { canIShow } = useGetAuthQuery(undefined, {
    selectFromResult: ({ data }) => ({
      canIShow: data?.companyType === companyType,
    }),
  });

  return canIShow;
};
